import { render, staticRenderFns } from "./perAuthentication.vue?vue&type=template&id=5d9e5d3c&scoped=true&"
import script from "./perAuthentication.vue?vue&type=script&lang=js&"
export * from "./perAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./perAuthentication.vue?vue&type=style&index=0&id=5d9e5d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e5d3c",
  null
  
)

export default component.exports